import { render } from "./TermsSection.vue?vue&type=template&id=0c194c44"
import script from "./TermsSection.vue?vue&type=script&lang=js"
export * from "./TermsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__